import {SerializedStyles} from '@emotion/react';
import {css, Typography, TypographyProps, useTheme} from '@mui/material';
import React from 'react';
import {useIntl} from 'react-intl';
import {useStore} from 'react-redux';

import {DlMuiPopper} from './DlMuiPopper';
import {GetStylesFunction} from 'src/js/common/types';
import {TranslateUtils} from 'src/js/common/utils';
import {getEnumValue} from 'src/js/containers/enum/enum_selectors';
import {useMuiAnchor} from 'src/js/hooks';

interface OwnProps extends TypographyProps {
  value?: string;
  enumValue?: string;
  enumName?: string;
  inputCss?: SerializedStyles;
  inputRef?: React.MutableRefObject<HTMLSpanElement>;
  title?: string;
}

type Props = OwnProps;

export const DlMuiTypography: React.FC<Props> = (props) => {
  const {
    variant,
    value,
    inputCss,
    enumValue,
    enumName,
    inputRef,
    title,
    ...restProps
  } = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {inputCss}});
  const intl = useIntl();
  const store = useStore();
  const state = store && store.getState();

  const translatedTitle =
    title && intl && TranslateUtils.translate(title, intl);
  const hasTooltip = !!translatedTitle;

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} =
    useMuiAnchor(hasTooltip);

  const enumValueFromEnums =
    enumName && enumValue && getEnumValue(state, enumName, enumValue);
  const translatedRiskFactorTypeEnumValue =
    enumValueFromEnums &&
    intl &&
    TranslateUtils.translate(enumValueFromEnums, intl);

  const translatedValue =
    intl && value && TranslateUtils.translate(value, intl);

  return (
    <>
      <Typography
        css={styles.typography}
        variant={variant}
        ref={inputRef}
        onMouseEnter={mouseEventEnter}
        onMouseLeave={mouseEventLeave}
        {...restProps}
      >
        {translatedRiskFactorTypeEnumValue ?? translatedValue}
      </Typography>
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
        <Typography variant={'popper'}>{translatedTitle}</Typography>
      </DlMuiPopper>
    </>
  );
};

DlMuiTypography.displayName = 'DlMuiTypography';

const getStyles: GetStylesFunction = (options) => ({
  typography: css(
    {
      color: `${options?.theme?.palette.custom.coolGray['900']}`,
    },
    options?.params?.inputCss
  ),
});
